import { useEffect, useRef, useState } from "react";
import type { ColumnDef } from "../lib/catalogColumns";

export function CatalogColumnPicker<T extends string>({
  columns,
  visible,
  onToggle,
}: {
  columns: ColumnDef<T>[];
  visible: T[];
  onToggle: (id: T) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const optional = columns.filter((c) => !c.locked);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="btn-ghost text-sm flex items-center gap-1"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        <span aria-hidden>⚙️</span>
        <span>Sloupce</span>
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-1 w-56 rounded-lg border bg-white shadow-lg p-3 text-sm">
          <p className="text-xs font-medium text-slate-500 mb-2">Zobrazené sloupce</p>
          <div className="space-y-1 max-h-64 overflow-y-auto">
            {columns.map((col) => (
              <label
                key={col.id}
                className={`flex items-center gap-2 py-1 ${col.locked ? "text-slate-400" : "cursor-pointer"}`}
              >
                <input
                  type="checkbox"
                  className="w-4 h-4"
                  checked={visible.includes(col.id)}
                  disabled={col.locked}
                  onChange={() => onToggle(col.id)}
                />
                <span>{col.label}</span>
              </label>
            ))}
          </div>
          {optional.length > 0 && (
            <p className="text-[10px] text-slate-400 mt-2">Nastavení se uloží v prohlížeči.</p>
          )}
        </div>
      )}
    </div>
  );
}
